import type { ReactNode } from "react";
import { RequireAuth as LibRequireAuth } from "@marekl/adminer/shell";
import { hasAnyGlobalRole, type SystemRole, type User } from "./queries";

interface Props {
  children: ReactNode;
  // If provided, the user must hold at least one of these global system
  // roles. Scope-specific checks (team / federation) belong inside the
  // page itself where the relevant id is known.
  roles?: SystemRole[];
}

/** Redirects to /login if the user is not authenticated, or to /dashboard if a role check fails. */
export function RequireAuth({ children, roles }: Props) {
  return (
    <LibRequireAuth
      fallbackPath="/dashboard"
      check={roles ? (user) => hasAnyGlobalRole(user as User, ...roles) : undefined}
    >
      {children}
    </LibRequireAuth>
  );
}
